import { connect } from 'react-redux';
import Respuestas from '../../../components/respuestas/Respuestas';
import { respuestas, profile, sucursal_id } from 'core/selectors';
import { getRespuestas } from 'core/slices/respuestas';

export default connect(
  state => ({
    respuestas: respuestas(state),
    profile: profile(state),
    sucursal_id: sucursal_id(state),
  }),
  { getRespuestas },
)(Respuestas);
